module.exports = __webpack_public_path__ + "static/media/admin-mockup.1c350b14.png";